import { createSelector } from 'reselect';

import { getActiveSite } from '../sites';

export const getIntegrationTypes = (state) => state.integrations.integrationTypes;

export const getIntegrationsLoaded = (state) => state.integrations.loadedScope;

export const getAllIntegrations = (state) => state.integrations.integrations;

export const getTemplates = createSelector(getAllIntegrations, (integrations) =>
  integrations.filter(({ site }) => !site)
);

export const getSiteIntegrations = createSelector(
  getActiveSite,
  getAllIntegrations,
  ({ id }, integrations) => {
    if (id) {
      return integrations.filter(({ site }) => site === id);
    }
    return [];
  }
);

export const getIntegrations = createSelector(getAllIntegrations, (integrations) =>
  integrations.filter(({ templateId, site }) => templateId && site)
);
